module.exports = __webpack_public_path__ + "media/images/redesign-images/textures/texture-u-1-6067b60591ff12c395895a4e12ea1731.svg";